import { updateField } from 'vuex-map-fields'

const SET_USER = (state, payload) => {
  state.user = payload
}

const SET_NAME = (state, payload) => {
  if (payload[0]) {
    state.user.name = payload[0].name
  }
}

const INITIALIZE_CURRENT_CLIENT = state => {
  let storedCurrentClient = window.localStorage.getItem('current_client')
  if (storedCurrentClient) {
    let fullClient = state.clients.find(x => x.clientNumber === storedCurrentClient)
    if (fullClient) {
      SET_CURRENT_CLIENT(state, fullClient)
      return
    }
  }

  if (state.clients.length > 0) {
    SET_CURRENT_CLIENT(state, state.clients[0])
  }
}

const SET_CURRENT_CLIENT = (state, payload) => {
  state.currentClient = payload.clientNumber
  state.currentClientId = payload.clientId
  state.currentClientName = payload.clientName
  state.currentClientACPReview = payload.acpReview
  state.currentClientHeaderTextReviews = payload.headerTextReviews ? payload.headerTextReviews : 'Reviews are conducted under attorney/client privelege'
  state.baseApiUrl = process.env.VUE_APP_API_BASE_URL + '/api/' + state.currentClient
  window.localStorage.setItem('current_client', state.currentClient)
}

const SET_CURRENT_CLIENT_BY_ID = (state, id) => {
  let client = state.clients.find(x => x.clientId === id)
  if (client) {
    SET_CURRENT_CLIENT(state, client)
  }
}

const SET_CLIENTS = (state, payload) => {
  state.clients = payload.filter(x => x.clientNumber)
}

const SET_PROFILEPHOTO = (state, payload) => {
  state.user.imageData = payload
}

export default {
  updateField,
  SET_USER,
  SET_CURRENT_CLIENT,
  SET_CLIENTS,
  SET_NAME,
  SET_CURRENT_CLIENT_BY_ID,
  INITIALIZE_CURRENT_CLIENT,
  SET_PROFILEPHOTO
}
